import { basicMsg, htmlMsg, valMsg } from "./swal_msg";
import { types } from "../types/types";
import { axiosProtectedReq, protectedReq } from "../helpers/requestHelper";
import { formatMonth } from "../helpers/admin/adminHelper";

// lista de pedidos - administrador
export const getOrders = (order_count, setTableInfo) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('order/list', {
                order_count
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                dispatch(ordersAdded(body.resp));
                const current = order_count + body.resp.length;
                setTableInfo(e => ({
                    ...e, order_count: current
                }));
            }
        } catch (err) {};
    };
};

const ordersAdded = (payload) => ({
    type: types.adminOrdersAdded, payload
});

// pedidos perdidos - administrador
export const getLostOrders = async(
    setCurrentDate, setFilter, setOrdersCache
) => {
    try {
        const resp = await protectedReq('order/get-incompleted');
        const body = await resp.json();
        if (body.status) {
            const {
                droppedOrders, years, today, currentYear, currentMonth, statuses
            } = body.resp;
            
            setCurrentDate({ years, today, currentYear, currentMonth });

            // filtro utilizado (año y mes actual)
            setFilter(e => ({
                ...e,  year: currentYear,
                months: [currentMonth], statuses
            }));

            if (droppedOrders.length > 0) {
                // llave para pedidos de este año y mes
                // ej: 2026-03
                const key = `${currentYear}-${String(currentMonth).padStart(2, '0')}`;
                // guardar pedidos en caché
                setOrdersCache(e => ({
                    ...e,
                    [key]: droppedOrders
                }));
            }
        } else
            valMsg('error', 'Pedidos incompletos',
            'No se pudo obtener la lista');
    } catch (err) {
        valMsg('error', 'Pedidos incompletos',
        'Hubo un incidente al obtener la lista');
    };
};

// obtener más pedidos incompletos acorde con filtros
export const getOrdersByFilter = async(
    year, months, setOrdersCache, setBackdrop
) => {
    try {
        const resp = await protectedReq('order/filtered', {
            year, months
        }, 'POST');
        const body = await resp.json();
        if (!body.status) {
            const { msg } = body;
            if (msg === 'no-results') {
                basicMsg('No se encontraron coincidencias');
                const emptyGroups = months.reduce((groups, month) => {
                    groups[`${year}-${formatMonth(month)}`] = [];
                    return groups;
                }, {});
                setOrdersCache(cache => ({ ...cache, ...emptyGroups }));
            } else if (msg === 'miss')
                basicMsg('Falta información de filtro aplicado');
            else if (msg === 'server-err')
                valMsg('error', 'Pedidos filtrados',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else
                valMsg('error', 'Pedidos filtrados',
                'No se pudo obtener la lista');
            return;
        }

        const { orders } = body.resp;
        // agrupar pedidos extraídos mediante key
        const grouped = orders.reduce((acc, order) => {
            const { orderDate: { year, month } } = order;
            const key = `${year}-${formatMonth(month)}`;

            if (!acc[key]) acc[key] = [];
            acc[key].push(order);

            return acc;
        }, {});
        // guardar pedidos en caché
        setOrdersCache(e => ({
            ...e, ...grouped
        }));
        return { status: true };
    } catch (err) {
        valMsg('error', 'Pedidos incompletos',
        'Hubo un incidente al obtener la lista');
        return { status: false };
    } finally {
        setBackdrop(false);
    };
};

// subir archivo
export const uploadOrderFile = async(file, order_num) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('order_num', order_num);
        const resp = await axiosProtectedReq('order/file', formData, 'POST');
        if (!resp.status) {
            if (resp.msg === 'file-not-uploaded')
                alert('Archivo no subido');
            else if (resp.msg === 'folder-not-created')
                alert('Carpeta no creada');
            else if (resp.msg === 'miss')
                alert(`Falta información de pedido #${order_num}`);
            else
                alert('Ocurrió un incidente');
        }
        return resp;
    } catch (err) {
        alert(`Pedido ${order_num}: No se pudo subir archivo`);
        return { status: false };
    }
};

// agrega guía de seguimiento
export const addTrackingGuide = (
    { id, order_num, partner, tracking }, setSelectedOrder, setLoading
) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('order/add-tracking', {
                id, partner, tracking 
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                setLoading(false);
                dispatch(updateOrder({
                    id, status: 'shipped',
                    partner, tracking
                }));
                setSelectedOrder(e => ({
                    ...e,
                    delivery_status: 'Enviado',
                    shipping: {
                        ...e.shipping,
                        status: 'shipped'
                    }
                }));
            } else {
                setLoading(false);
                if (body.msg === 'miss')
                    alert(`Pedido ${order_num}: Falta información`);
                else if (body.msg === 'order-not-upd')
                    alert(`Pedido ${order_num}: No actualizado`);
                else if (body.msg === 'server-err')
                    alert(`Pedido ${order_num}: Error en el servidor`);
                else
                    alert(`Pedido ${order_num}: Incidente al agregar guía de seguimiento`);
            }
        } catch (err) {
            setLoading(false);
            alert(`Pedido ${order_num}: No se pudo agregar guía de seguimiento`);
        };
    };
};

// marcar pedido como entregado
export const orderDelivered = (
    { id, order_num }, setSelectedOrder, setLoading
) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('order/delivered', { id, order_num }, 'PUT');
            const body = await resp.json();
            if (body.status) {
                setLoading(false);
                dispatch(updateOrder({
                    id, status: 'delivered'
                }));
                setSelectedOrder(e => ({
                    ...e,
                    delivery_status: 'Entregado',
                    shipping: {
                        ...e.shipping,
                        status: 'delivered'
                    }
                }));
            } else {
                setLoading(false);
                if (body.msg === 'miss')
                    alert(`Pedido ${order_num}: Falta información`);
                else if (body.msg === 'order-not-upd')
                    alert(`Pedido ${order_num}: No actualizado`);
                else if (body.msg === 'server-err')
                    alert(`Pedido ${order_num}: Error en el servidor`);
                else
                    alert(`Pedido ${order_num}: Incidente al marcar como entregado (${
                        body.msg ? body.msg : 'Desconocido'
                    })`);
            }
        } catch (err) {
            setLoading(false);
            alert(`Pedido ${order_num}: No se pudo marcar pedido como entregado`);
        };
    };
};

// actualizar pedido en BD (enviado/entregado)
const updateOrder = (payload) => ({
    type: types.adminUpdateOrder, payload
});

export const odooOrders = async() => {
    try {
        const resp = await protectedReq('order/odoo');
        const body = await resp.json();
        return body;
    } catch (err) {
        htmlMsg('error', 'Pedidos en Odoo',
        `<p>No se pudo recuperar pedidos de BD</p><h6>Error: ${err}</h6>`);
        return { status: false };
    };
};
